<h2 mat-dialog-title class="text-lg font-bold mb-1">
  {{ "Horarios de entrega" }}
</h2>
<mat-dialog-content class="modal-content">
  <table
    mat-table
    [dataSource]="dataSource"
    class="min-w-500 overflow-y-visible mat-elevation-z"
  >
    <ng-container matColumnDef="day">
      <th mat-header-cell *matHeaderCellDef>Dia</th>
      <td mat-cell *matCellDef="let element">
        {{ getDayName(element.day) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="hourStart">
      <th mat-header-cell *matHeaderCellDef>Hora Inicio</th>
      <td mat-cell *matCellDef="let element">
        {{ element.hourStart }}
      </td>
    </ng-container>

    <ng-container matColumnDef="hourEnd">
      <th mat-header-cell *matHeaderCellDef>Hora Fin</th>
      <td mat-cell *matCellDef="let element">
        {{ element.hourEnd }}
      </td>
    </ng-container>

    <ng-container matColumnDef="statusId">
      <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
      <td mat-cell *matCellDef="let element" class="px-6 text-left">
        <mat-slide-toggle
          [checked]="element.statusId == 1"
          (change)="onStatusChange($event.checked, element)"
          color="primary"
        >
        </mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <button
          color="primary"
          mat-button
          (click)="openAddBPScheduleModal()"
          matTooltip="Agregar"
        >
          <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="button-container">
          <button mat-icon-button (click)="openAddBPScheduleModal(element)">
            <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
          </button>
          <button mat-icon-button (click)="openDeleteBPSchedule(element)">
            <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex justify-end">
  <button mat-button mat-dialog-close class="align-right">Aceptar</button>
</mat-dialog-actions>
